<mat-slider min="1" max="{{values.length}}" step="1" value="{{position}}" class="{{cssClasses}}"
            [tabIndex]="disableTabFocus == true ? -1 : tabindex"
            [attr.aria-label]="ariaLabel"
            [attr.aria-valuenow]="selected"
            [attr.aria-valuetext]="selected"
            [ngClass]="{'disable-tab-focus': disableTabFocus}"
            [disabled]="disabled"
            (change)="slided($event)">
</mat-slider>
<label class="label" *ngIf="showLabel && !durationSlider">
    {{ selected.toLowerCase() }}
</label>
<label class="label" *ngIf="showLabel && durationSlider">
    {{ selected | durationTranslation }}
</label>
